import { startGameFlow } from "../../game";

/**
 * Po wysłaniu zgłoszenia gracz przechodzi wprost do gry (js/game/index.js).
 *
 * Podsumowania zgłoszenia już nie ma: wyjście z modalu przeładowuje stronę, więc po
 * rozgrywce zostaje czysty formularz, a nie ekran z danymi, które gracz przed chwilą podał.
 */
$('.application-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    $('section#application .page').addClass('d-none');

    // Gra niedostępna (brak modalu, brak uuid) — przeładowanie zostawia gracza z czystym
    // formularzem, dokładnie tak jak wyjście z modalu po rozgrywce.
    if (!startGameFlow(data)) {
        window.location.reload();
    }
});

$('[name="personal_data[billType]"]').on('change', function() {
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');
